import { action } from 'satcheljs';
export default action('MARK_CONVERSATIONS_AS_READ_STORE_UPDATE', function (conversationIds, tableViewId, isReadValue) {
    return {
        conversationIds: conversationIds,
        tableViewId: tableViewId,
        isReadValue: isReadValue,
    };
});
//# sourceMappingURL=markConversationsAsReadStoreUpdate.js.map